/**
 * Created by lowdev on 1/4/18.
 */
const config = {
  api: {
    staff: {
      list: '/api/staffs/',
      details: '/api/staffs/<id>/'
    },
    support: {
      list: '/api/supports/',
      details: '/api/supports/<id>/'
    },
    opendate: {
      details: '/api/activity/<id>/open-date/'
    },
    activityprice: {
      details: '/api/activity/<id>/price/'
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./skippair/static/js/api.config.js